export default {
  title: 'Tables',
  count_one: '{{count}} table',
  count_other: '{{count}} tables',
  filtered_count: '{{shown}} of {{count}} tables',
  intro:
    'Each table has its own link and QR code. Guests who scan it order to that table, and you see the table on every order.',
  migrated: {
    title: 'Room/Table service is now Table ordering',
    description:
      'We added a table for each of your locations, named after it, so guests can keep ordering. Rename them to match your tables, or add more.',
  },
  add: {
    label: 'Add a table',
    placeholder: 'e.g. 7, 1A or Terrace 2',
    button: 'Add table',
  },
  errors: {
    empty: 'Enter a table name.',
    duplicate: 'There’s already a table called “{{name}}”.',
    too_long: 'A table name can have up to {{max}} characters.',
  },
  columns: {
    order: 'Order',
    table: 'Table and link',
    on: 'On',
    copy: 'Copy link',
    qr: 'QR code',
    actions: 'Actions',
  },
  switch: {
    on: 'On',
    off: 'Off',
  },
  buttons: {
    copy: 'Copy link',
    copied: 'Copied',
    download_qr: 'Download QR code',
    qr_short: 'QR code',
    rename: 'Rename',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
  },
  aria: {
    move: 'Move {{name}} (arrow keys)',
    switch: '{{name}} on',
    copy: 'Copy link for {{name}}',
    copied: 'Link copied',
    download_qr: 'Download QR code for {{name}}',
    rename: 'Rename {{name}}',
    delete: 'Delete {{name}}',
    more: 'More for {{name}}',
    new_name: 'New name for {{name}}',
  },
  tooltips: {
    move: 'Drag to reorder',
    move_disabled: 'Clear the search to reorder',
  },
  rename_hint: 'The link and QR code stay the same.',
  no_link: 'No shop address yet',
  search: {
    placeholder: 'Search tables',
    no_results: 'No table called “{{text}}”.',
  },
  load_failed: {
    title: 'The tables couldn’t be loaded.',
    retry: 'Try again',
  },
  empty: {
    title: 'No tables yet',
    text: 'Add your tables above to get a link and QR code for each. Guests can’t order at a table until you add one.',
  },
  delete: {
    title: 'Delete table “{{name}}”?',
    warning: 'Printed QR codes for this table will stop working. Guests who scan one are asked to ask the staff.',
    softer: 'To stop orders at this table for a while, switch it off instead.',
    confirm: 'Delete table',
    cancel: 'Cancel',
  },
  announcements: {
    moved: '“{{name}}” moved to position {{position}} of {{count}}.',
    instructions: 'To move a table, focus its handle and press the up or down arrow key.',
  },
  qr_image: {
    table: 'Table',
  },
  toasts: {
    added: 'Table “{{name}}” added',
    renamed: '“{{old}}” renamed to “{{name}}”',
    deleted: 'Table “{{name}}” deleted',
    switched_on: '“{{name}}” switched on',
    switched_off: '“{{name}}” switched off',
    failed_to_save: 'That didn’t save. Please try again.',
    failed_to_reorder: 'The new order didn’t save. Please try again.',
    failed_to_download_qr: 'The QR code couldn’t be saved. Please try again.',
    copy_failed: 'The link couldn’t be copied. Please try again.',
  },
};
